import { createFileRoute } from "@tanstack/react-router";
import LearnHub from "@/pages/resources/LearnHub";

export const Route = createFileRoute("/learn/")({
  head: () => ({
    meta: [
        {
            "title": "Learn Hub – Study Guides & Revision Techniques | System Atlas"
        },
        {
            "name": "description",
            "content": "Free study guides on active recall, spaced repetition, the Feynman technique, and AI-powered revision. Evidence-based methods to study smarter."
        },
        {
            "property": "og:title",
            "content": "Learn Hub – Study Guides & Revision Techniques | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Free study guides on active recall, spaced repetition, the Feynman technique, and AI-powered revision. Evidence-based methods to study smarter."
        },
        {
            "property": "og:type",
            "content": "website"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/learn"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Learn Hub – Study Guides & Revision Techniques | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Free study guides on active recall, spaced repetition, the Feynman technique, and AI-powered revision. Evidence-based methods to study smarter."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    scripts: [{ type: "application/ld+json", children: JSON.stringify({"@context": "https://schema.org", "@type": "CollectionPage", "name": "Learning Guides", "description": "Free guides on study techniques and revision.", "url": "https://systematlas.fr/learn", "inLanguage": "en", "isPartOf": {"@type": "WebSite", "name": "System Atlas", "url": "https://systematlas.fr"}}) }],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/learn"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn"
        },
        {
            "rel": "alternate",
            "hrefLang": "es",
            "href": "https://systematlas.fr/es/learn"
        },
        {
            "rel": "alternate",
            "hrefLang": "de",
            "href": "https://systematlas.fr/de/learn"
        },
        {
            "rel": "alternate",
            "hrefLang": "it",
            "href": "https://systematlas.fr/it/learn"
        },
        {
            "rel": "alternate",
            "hrefLang": "pt",
            "href": "https://systematlas.fr/pt/learn"
        },
        {
            "rel": "alternate",
            "hrefLang": "pl",
            "href": "https://systematlas.fr/pl/learn"
        },
        {
            "rel": "alternate",
            "hrefLang": "zh",
            "href": "https://systematlas.fr/zh/learn"
        },
        {
            "rel": "alternate",
            "hrefLang": "hi",
            "href": "https://systematlas.fr/hi/learn"
        }
    ],
  }),
  component: LearnHub,
});
